import React, { useState } from 'react'
import { RouteComponentProps } from 'react-router-dom'

import { Box } from 'components/Box'
import { Tabs, TabPanel } from 'components/Tabs'
import Tab from 'components/Tabs/Tab'
import TabList from 'components/Tabs/TabList'

import NotificationsListWithData from 'modules/activity/components/Notifications/NotificationsListWithData'

import { RouteParams } from 'constants/routes'
import localStorageKeys from 'constants/localStorageKeys'
import WorkspaceSidebarLayout from 'modules/workspace/components/WorkspaceSidebarLayout'
import { getItem } from 'utils/localStorage'
import { useGetWorkspaces } from 'modules/workspace/operations'
import { DynamicLoadingPage } from 'containers/DynamicLoadingPage'
import GenericErrorView from 'views/GenericErrorView'

/**
 * TYPES
 */
type UpdatesRoutesProps = RouteComponentProps<RouteParams<'UPDATES'>>

/**
 * MAIN COMPONENT
 */
export const Updates: React.FC<UpdatesRoutesProps> = props => {
  const [workspaceId] = useState<string | undefined>(
    getItem(localStorageKeys.lastWorkspaceIdKey)
  )

  const { workspaces, loading, error } = useGetWorkspaces()

  if (loading) {
    return <DynamicLoadingPage />
  }

  if (error) {
    return <GenericErrorView error={error} />
  }

  const currentWorkspace =
    workspaces?.find(({ identifier }) => workspaceId === identifier) ||
    workspaces?.[0]

  return (
    <WorkspaceSidebarLayout
      title="Updates"
      currentWorkspace={currentWorkspace}
      workspaces={workspaces}
      navbar={
        <Box ml={2}>
          <Tabs>
            <TabList>
              <Tab>Inbox</Tab>
              <Tab externalUrl="https://www.sketch.com/blog/product/">
                New in Sketch &#x2197;
              </Tab>
            </TabList>
            {/* In this specific situation we don't need to use TabPanel as we
                only have one active tab, and the content will be shown as a
                children of SplitLayout */}
            <TabPanel>{null}</TabPanel>
          </Tabs>
        </Box>
      }>
      <NotificationsListWithData />
    </WorkspaceSidebarLayout>
  )
}
